/*
 *   File : consent.js
 *   Author URI : https://evoqins.com
 *   Description : Confirmation modal to accept T&C
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState } from "react";
import style from "../../Styles/Component/announcement.module.scss"
import { GradientButton, OutlineButton } from "../CTA";
import { Icon } from "../Icon";
import APIService from "../../Service/api-service";
import { toast } from "react-toastify";
import { OTPInput } from "../Form-elements";

const AcceptPanConsent = (props) => {
    const [isAccepted, setIsAccepted] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);
    const [mobileOtp, setMobileOtp] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [seconds, setSeconds] = useState(30);
    const [userData, setUserData] = useState({});

    useEffect(() => {
        var my_modal = document.getElementById("pan-consent");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, [props.close]);

    useEffect(() => {
        if (otpSent) {
            setSeconds(29);
        }
    }, [otpSent]);

    useEffect(() => {
        const countdown = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else {
                clearInterval(countdown);
                // Handle expiration logic here (e.g., show a resend button)
            }
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, [seconds]);

    useEffect(() => {
        var my_modal = document.getElementById("pan-consent");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, [props.close]);

    function _handleAcceptConsent(is_resent = false) {
        if (is_resent === false) {
            setApiLoader(true);
        }
        const url = "kyc/dedupe-consent";

        const payload = {
            consent: isAccepted,
            email: props.apiData?.email,
            mobile: props.apiData?.mobile,
            name: props.apiData?.name,
            pan: props.apiData?.pan,
            ucc: props.apiData?.ucc
        }

        APIService(true, url, payload, "access", true).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                setOtpSent(true);
                setUserData(response);
                setMobileOtp("");
                toast.success(is_resent === true ? "OTP resent successfully" : "OTP sent successfully");
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        });
    }

    function _handleVerifyOtp() {
        if (mobileOtp === "") {
            setMobileError("Please enter OTP");
            return;
        }
        if (mobileOtp.length < 4) {
            setMobileError("Invalid OTP");
            return;
        }
        setApiLoader(true);
        const url = "kyc/verify-consent";

        const payload = {
            otp: mobileOtp,
            email: props.apiData.email,
            mobile: props.apiData.mobile,
            name: props.apiData?.name,
            pan: props.apiData?.pan,
            ucc: props.apiData?.ucc
        }

        APIService(true, url, payload, "access", true).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                setOtpVerified(true);
            } else {
                toast.error(response.message);
            }
            setApiLoader(false);
        });
    }

    return (
        <div className={`modal fade ${style.e_announcement_modal}`}
            id="pan-consent"
            tabIndex="-1"
            aria-labelledby="pan-consent"
            aria-hidden="true"
            data-bs-backdrop="static" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-body-color text-start d-flex align-items-center padding-32px-all ${style.e_content} `}>
                    {
                        otpVerified === false ?
                            <Icon icon="close"
                                size={24}
                                id="close-modal"
                                data-bs-dismiss="modal"
                                className={`position-absolute top-20px cursor-pointer e-modal-close-btn right-32 ${style.e_close}`} />
                            : null
                    }




                    {
                        otpVerified ?
                            <div className="row">
                                <div className="col-12 ">

                                    <p className="color-black e-poppins-semi-bold e-font-16 mb-0 text-center mt-4">
                                        Thank You for Request Submission!
                                    </p>
                                    <p className="color-black e-poppins-regular e-font-16 mb-0 text-center mt-4">
                                        Your Mutual Fund activation request has been received successfully. It will be
                                        activated within 24–48 hours subject to request review.
                                    </p>
                                </div>

                                <div className="margin-32px-top d-sm-flex d-block justify-content-center gap-8px ">

                                    <GradientButton label="Close"
                                        handleClick={() => props.accept()}
                                        cancel="modal"
                                        className="e-font-16 padding-70px-lr padding-12px-tb w-mobile-100 mt-sm-0 mt-3" />
                                </div>
                            </div>
                            :
                            otpSent ?
                                <div className="row">
                                    <div className="col-12 ">
                                        <h5 className="color-almost-black e-poppins-semi-bold e-font-18 text-start">
                                            Verify you Identity
                                        </h5>
                                        <p className="color-black e-poppins-regular e-font-16 mb-0 text-start mt-4">
                                            We’ve sent a One-Time Password (OTP) to your registered email {userData?.masked_email} or mobile number {userData?.masked_mobile}.
                                        </p>

                                        <div className="mt-4 pt-2">
                                            <OTPInput pinString={mobileOtp}
                                                id="sip-otp"
                                                autoFocus={true}
                                                pinError={mobileError}
                                                handleChange={(value) => setMobileOtp(value)} />
                                        </div>

                                    </div>

                                    <div className="margin-32px-top d-sm-flex d-block justify-content-center gap-8px ">
                                        <OutlineButton label="Back"
                                            className="e-font-16 padding-70px-lr padding-12px-tb w-mobile-100 mt-sm-0 mt-3"
                                            handleClick={() => { setOtpSent(false); setMobileOtp(""); setMobileError("") }} />
                                        <GradientButton label="Verify"
                                            disabled={apiLoader}
                                            handleClick={() => _handleVerifyOtp(false)}
                                            loading={apiLoader}
                                            className="e-font-16 padding-70px-lr padding-12px-tb w-mobile-100 mt-sm-0 mt-3" />
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                        {
                                            seconds === 0 ?
                                                <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-pointer mb-0 e-forgot-pin position-relative w-max-content resend'
                                                    onClick={() => {
                                                        setSeconds(30);
                                                        _handleAcceptConsent(true);
                                                    }}>Resend OTP</p>
                                                :
                                                <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-not-allowed mb-0 '>
                                                    Resend OTP in <span className="color-black">{seconds}s</span>
                                                </p>
                                        }

                                    </div>
                                </div>
                                :
                                <div className="row mt-3">
                                    <div className=" border-radius-8px bg-antique-white py-2 padding-6px-lr mb-3">
                                        <div className="row">
                                            <div className="col-1 pe-0 text-center">
                                                <Icon icon="info"
                                                    size={24} />
                                            </div>
                                            <div className="col-11">
                                                <p className="color-jett-black e-poppins-regular e-font-14 mb-0">
                                                    You already have an existing account with us. With your consent, we’ll activate your Mutual Fund account using your existing code. The account will be activated within 24–48 working hours, and you can log in with your existing details. Once submitted, you’ll be logged out from the onboarding process. Thank you!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 ">
                                        <h5 className="color-almost-black e-poppins-semi-bold e-font-18 text-start">
                                            Declaration & Consent
                                        </h5>
                                        <p className="color-black e-poppins-regular e-font-16 mb-0 text-start mt-2">
                                            By proceeding, I hereby confirm that:
                                        </p>
                                        <p className="color-black e-poppins-regular e-font-16 mb-0 text-start mt-2">
                                            I am interested in availing the trading facility of the Exchanges for dealing in
                                            Mutual Funds through MFSS, BSE StAR MF, and/or any other approved Mutual
                                            Fund platforms. There is no change in my Know Your Client (KYC) details already
                                            submitted for stock broking and the same may be utilized for this facility.
                                            <br />I agree to abide by the <a className="color-primary-color e-poppins-medium" href="https://mastertrust-files.s3.ap-south-1.amazonaws.com/public/MF_terms_and_conditions.pdf" target="_blank">terms and conditions</a> prescribed by NSE (Circular dated 24
                                            Nov 2009), BSE (Circular dated 2 Dec 2009), SEBI, AMFI, and the respective
                                            Exchanges, as amended from time to time.
                                        </p>

                                    </div>
                                    <div className={`d-flex align-items-center gap-1 mt-4`}>
                                        <Icon icon={isAccepted === true ? "cart-selected" : 'cart-unselected'}
                                            size={24}
                                            className='cursor-pointer'
                                            onClick={() => setIsAccepted(!isAccepted)} />
                                        <span className="color-text-black e-poppins-medium e-font-16 line-height-16px">
                                            I agree and provide my consent.
                                        </span>
                                    </div>
                                    <div className="margin-32px-top d-sm-flex d-block justify-content-center gap-8px ">

                                        <GradientButton label="Continue"
                                            disabled={isAccepted === false || apiLoader}
                                            handleClick={() => _handleAcceptConsent(false)}
                                            loading={apiLoader}
                                            className="e-font-16 padding-70px-lr padding-12px-tb w-mobile-100 mt-sm-0 mt-3" />
                                    </div>
                                </div>

                    }
                </div>
            </div>
        </div>
    )
}

export default AcceptPanConsent